import { Box, Stack, Tooltip } from "@mui/material";

import type { StackProps } from "@mui/material";
import type { FC } from "react";

export const TableStack: FC<
  StackProps & {
    tooltip?: string;
  }
> = ({ children, tooltip, ...props }) => (
  <Stack
    direction="column"
    spacing={1}
    {...props}
    sx={[
      {
        alignItems: "flex-start",
        height: "100%",
        py: 2,
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  >
    <Tooltip title={tooltip} arrow placement="top">
      {/* To avoid making every child a forward ref,
         just wrap in a content sized box */}
      <Box>{children}</Box>
    </Tooltip>
  </Stack>
);
